export const enum Type {
  SERVICE_ANNOUNCEMENT = 'SERVICE_ANNOUNCEMENT',
  COURSE_NEW_NEWS = 'COURSE_NEW_NEWS',
  COMMUNITY_COMMENT = 'COMMUNITY_COMMENT',
  MARKETING = 'MARKETING',
  MARKETING_EMAIL = 'MARKETING_EMAIL',
  MARKETING_KAKAO = 'MARKETING_KAKAO',
  MARKETING_SMS = 'MARKETING_SMS',
  STUDY_SUMMARY = 'STUDY_SUMMARY',
}

export const enum EmailTokenType {
  ENCRYPT = 'ENCRYPT',
  MAILTOKEN = 'MAILTOKEN',
}

export const ORDERS_META = {
  title: '메타.주문내역.제목',
  description: '메타.주문내역.설명',
};

export const NOTIFICATION_META = {
  title: '메타.알림설정.제목',
  description: '메타.알림설정.설명',
} as const;

export const DEVICE_META = {
  title: '메타.기기관리.제목',
  description: '메타.기기관리.설명',
} as const;

export const notificationTypeMapper = {
  courseNewNews: Type.COURSE_NEW_NEWS,
  serviceAnnouncement: Type.SERVICE_ANNOUNCEMENT,
  marketing: Type.MARKETING,
  communityComment: Type.COMMUNITY_COMMENT,
  marketingEmail: Type.MARKETING_EMAIL,
  marketingKakao: Type.MARKETING_KAKAO,
  marketingSms: Type.MARKETING_SMS,
  studySummary: Type.STUDY_SUMMARY,
} as const;

export const initialNotificationStatus = {
  [Type.COMMUNITY_COMMENT]: false,
  [Type.COURSE_NEW_NEWS]: false,
  [Type.MARKETING]: false,
  [Type.SERVICE_ANNOUNCEMENT]: false,
  [Type.MARKETING_EMAIL]: false,
  [Type.MARKETING_KAKAO]: false,
  [Type.MARKETING_SMS]: false,
  [Type.STUDY_SUMMARY]: false,
};

export const EMAIL_TOKEN_TYPE = {
  ENCRYPT: 'ENCRYPT',
  MAILTOKEN: 'MAILTOKEN',
} as const;
